module.exports = __webpack_public_path__ + "static/media/hackers_foundpool.db463f65.gif";